// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
// ✅ Import icons for social media links
import { SiX, SiLinkedin, SiInstagram } from 'react-icons/si';

const Footer = () => {
  const linkGroups = [
    {
      title: 'Product',
      links: [
        { label: 'AI & Automation', to: '/ai-automation' },
        { label: 'Scheduling', to: '/scheduling' },
        { label: 'Analytics', to: '/analytics' },
        { label: 'Engagements', to: '/engagements' },
      ],
    },
    {
      title: 'Solutions',
      links: [
        { label: 'Manage Social Media', to: '/manage-social-media' },
        { label: 'Gather Deep Insights', to: '/gather-deep-insights' },
        { label: 'Drive More Sales', to: '/drive-more-sales' },
        { label: 'Brand Awareness', to: '/brand-awareness' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'Schedule a Demo', to: '/schedule-demo' },
        { label: 'Pricing', to: '/pricing' },
        { label: 'Blog', to: '/blog' },
        { label: 'Affiliate Program', to: '/affiliate-program' },
        { label: 'Privacy', to: '/privacy' },
        { label: 'Terms', to: '/terms' },
      ],
    },
    // ✅ ADD NEW CONTACT COLUMN
    {
        title: 'Contact',
        links: [
            { label: 'Yogesh@oolook.in', to: 'mailto:Yogesh@oolook.in' },
        ],
    },
  ];

  // ✅ DEFINE SOCIAL MEDIA LINKS
  const socialLinks = [
    { name: 'X', href: 'https://x.com/OolookTweet', icon: SiX },
    { name: 'LinkedIn', href: 'https://www.linkedin.com/company/oolook-app/?viewAsMember=true', icon: SiLinkedin },
    { name: 'Instagram', href: 'https://www.instagram.com/oolook.app/', icon: SiInstagram },
  ];

  return (
    <footer className="bg-dark-bg text-dark-text-secondary border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          {/* Logo and tagline section */}
          <div className="space-y-4">
            <Link to="/" className="text-2xl font-bold text-dark-text-primary">
              Oolook
            </Link>
            <p className="text-sm leading-6">
              Your AI co-pilot for social media. Tame the chaos and focus on growth.
            </p>
          </div>
          
          {/* Links section - updated grid to accommodate 4 columns */}
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-dark-text-primary">{linkGroups[0].title}</h3>
                <ul className="mt-6 space-y-4">
                  {linkGroups[0].links.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to} className="text-sm leading-6 hover:text-dark-text-primary transition-colors">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6 text-dark-text-primary">{linkGroups[1].title}</h3>
                <ul className="mt-6 space-y-4">
                  {linkGroups[1].links.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to} className="text-sm leading-6 hover:text-dark-text-primary transition-colors">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-dark-text-primary">{linkGroups[2].title}</h3>
                <ul className="mt-6 space-y-4">
                  {linkGroups[2].links.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to} className="text-sm leading-6 hover:text-dark-text-primary transition-colors">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6 text-dark-text-primary">{linkGroups[3].title}</h3>
                <ul className="mt-6 space-y-4">
                  {linkGroups[3].links.map((link) => (
                    <li key={link.label}>
                      <a href={link.to} className="text-sm leading-6 hover:text-dark-text-primary transition-colors">
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom section with copyright and social links */}
        <div className="mt-16 flex items-center justify-between border-t border-white/10 pt-8 sm:mt-20 lg:mt-24">
          <p className="text-xs leading-5">&copy; {new Date().getFullYear()} Oolook. All rights reserved.</p>
          <div className="flex space-x-6">
            {socialLinks.map((item) => (
              <a key={item.name} href={item.href} target="_blank" rel="noopener noreferrer" className="hover:text-dark-text-primary transition-colors">
                <span className="sr-only">{item.name}</span>
                <item.icon className="h-5 w-5" aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;